import apiClient from '../ApiClient';

export const setUnreadNotificationsAsRead = async (): Promise<any> => {
    const res = await apiClient.get('notifications/clear');
    return res.data?.data;
};